import { useEffect, useState } from "react";
import { CloseGreyIcon } from "../../../assets/icons";
import { UserReportInfoSettingsDTO } from "../../../models/userReport/userReport.response";
import { useNotification } from "../../toster-notification/NotificationContext";
import Loader from "../../shared/Loader";
import { UserReportsService } from "../../../services/userReportsService";
import { ToLocalDateTimeString } from "../../../utils/dateFormater";
import { getUserReportStatusTypeToString, UserReportStatusType } from "../../../models/base/UserReportStatusType";
import UserModalTrigger from "../../shared/user-modal/UserModalTrigger";
import { getUserReportReasonTypeToString } from "../../../models/base/UserReportReasonType";
import OrderInfoModalView from "../../live-orders/shared/views/modal-view/OrderInfoModalView";


interface UserReportInfoViewProps {
    id: string;
    onClose: () => void;
}

const UserReportInfoView: React.FC<UserReportInfoViewProps> = ({ id, onClose }) => {

    const [isOrderInfoViewOpen, setIsOrderInfoViewOpen] = useState<boolean>(false);

    const [reportInfo, setReportInfo] = useState<UserReportInfoSettingsDTO>();

    const [note, setNote] = useState<string>('');
    const [selectedStatus, setSelectedStatus] = useState<UserReportStatusType | "">("");

    const [loading, setLoading] = useState<boolean>(false);
    const { notify } = useNotification();


    useEffect(() => {
        fetchReportInfo();
    }, []);


    const fetchReportInfo = async () => {

        console.log("Fetching report info for ID:", id); // Debug log
        setLoading(true);
        try {
            const response = await UserReportsService.getUserReportSettings(id);

            if (response && response.data) {
                setReportInfo(response.data);
                setSelectedStatus(response.data.status);
            } else {
                notify("error", "Nije moguće pronaći informacije o prijavi");
            }
        } catch (error) {
            notify("error", "Greška prilikom učitavanja informacija o prijavi");
        } finally {
            setLoading(false);
        }
    }

    const handleSaveChanges = async () => {
        if (!selectedStatus) {
            notify("error", "Molimo odaberite status prijave");
            return;
        }

        console.log("Selected status:", selectedStatus);

        setLoading(true);
        try {
            const response = await UserReportsService.updateUserReportSettings(id, { reviewNote: note, status: Number(selectedStatus) });

            if (response.success) {
                notify("success", "Uspešno ažurirani podaci o prijavi");
                onClose();
            } else {
                notify("error", "Nije moguće ažurirati informacije o prijavi");
            }
        } catch (error) {
            notify("error", "Greška prilikom ažuriranja informacija o prijavi");
        } finally {
            setLoading(false);
        }
    }



    if (loading) {
        return <Loader />;
    }

    if (!reportInfo) {
        return (
            <section className="modal-section report-info" onClick={onClose}>
                <div className="w-layout-blockcontainer container w-container">
                    <div className="modal-wrapper" >
                        <div className="modal-div" onClick={(e) => e.stopPropagation()}>
                            Report info not found
                        </div>
                    </div>
                </div>
            </section>
        )
    }

    return (
        <>
        {/* TO DO: napraviti poseban view za order gde ne treba local id, kao i za rezervaciju */}
            {isOrderInfoViewOpen && (
                <OrderInfoModalView
                    selectedOrderId={reportInfo.orderId || ''}
                    onClose={() => setIsOrderInfoViewOpen(false)}
                />
            )}

            <section className="modal-section report-info">
                <div className="w-layout-blockcontainer container w-container">
                    <div className="modal-wrapper">
                        <div className="modal-div">
                            <div className="modal-header-div">
                                <div>
                                    <div className="modal-header">Detalji prijave #{reportInfo?.id}</div>
                                    <div className="description-text">
                                        Pregled i upravljanje prijavom korisnika<br />
                                    </div>
                                </div>
                                <div className="modal-button-div" onClick={onClose}>
                                    <img loading="lazy" src={CloseGreyIcon} alt="" className="icon-size-20 close" />
                                </div>
                            </div>
                            <div className="modal-div-body red-bg">
                                <div className="modal-div-body-header">
                                    <div className="modal-div-body-header-text">
                                        Prijavljeni korisnik<br />
                                    </div>
                                </div>
                                <div className="div-block-39">
                                    <div>
                                        <div className="description-text">Ime i prezime</div>
                                        <div className="_0-95rem">
                                            <UserModalTrigger
                                                id={reportInfo.reportedUserId}
                                                name={reportInfo.reportedUserFullName}
                                            />
                                        </div>
                                    </div>
                                    <div>
                                        <div className="description-text">Telefon</div>
                                        <div className="_0-95rem">{reportInfo.reportedUserPhoneNumber || 'Nema telefona'}</div>
                                    </div>
                                </div>
                                <div className="div-block-39">
                                    <div>
                                        <div className="description-text">Email</div>
                                        <div className="_0-95rem">{reportInfo.reportedUserEmail}</div>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-div-body grey-bg reservation">
                                <div className="modal-div-body-header">
                                    <div className="modal-div-body-header-text">Detalji prijave</div>
                                </div>
                                <div className="div-block-39">
                                    <div>
                                        <div className="description-text">Lokacija</div>
                                        <div className="_0-95rem">{reportInfo.localName}</div>
                                    </div>
                                    <div>
                                        <div className="description-text">Prijavio</div>
                                        <div className="_0-95rem">
                                            <UserModalTrigger
                                                id={reportInfo.reportedByUserId}
                                                name={reportInfo.reportedByUserFullName}
                                            />
                                        </div>
                                    </div>
                                </div>
                                {(reportInfo.orderId || reportInfo.reservationId) && (
                                    <div className="div-block-39">
                                        {reportInfo.orderId && (
                                            <div>
                                                <div className="description-text">Porudžbina ID</div>
                                                <div className="_0-95rem" onClick={() => {
                                                    console.log("Opening order info for order ID:", reportInfo.orderId); // Debug log
                                                    setIsOrderInfoViewOpen(true)
                                                }}>
                                                    {reportInfo.orderId}
                                                </div>
                                            </div>
                                        )}
                                        {reportInfo.reservationId && (
                                            <div>
                                                <div className="description-text">Rezervacija ID</div>
                                                <div className="_0-95rem">{reportInfo.reservationId}</div>
                                            </div>
                                        )}
                                    </div>
                                )}
                                <div className="div-block-39 one-column">
                                    <div id="w-node-_3af108c2-8911-63dc-ba4b-91c01ade8e19-7969b2d6">
                                        <div className="description-text">Tip prijave: {getUserReportReasonTypeToString(reportInfo.reasonType)}</div>
                                    </div>
                                </div>
                                <div className="div-block-39 one-column">
                                    <div id="w-node-_3af108c2-8911-63dc-ba4b-91c01ade8e19-7969b2d6">
                                        <div className="description-text">Poruka</div>
                                        <div className="input-div white-bg">
                                            <div className="_0-95rem">{reportInfo.description}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-div-body light-blue-bg">
                                <div className="modal-div-body-header">
                                    <div className="modal-div-body-header-text">Super Admin akcije</div>
                                </div>
                                <div className="div-block-39 one-column">
                                    <div>
                                        <div className="description-text">Promeni status (Trenutni: {getUserReportStatusTypeToString(reportInfo.status)})</div>
                                        <select className="form-select width-100 w-select"
                                            value={selectedStatus}
                                            onChange={(e) => setSelectedStatus(e.target.value as UserReportStatusType | '')}
                                        >
                                            <option value="">Odaberi...</option>

                                            {Object.values(UserReportStatusType)
                                                .filter((value) => typeof value === "number")
                                                .map((value) => (
                                                    <option key={value} value={value}>
                                                        {getUserReportStatusTypeToString(value as UserReportStatusType)}
                                                    </option>
                                                ))}

                                        </select>
                                    </div>
                                </div>
                                <div className="div-block-39 one-column">
                                    <div>
                                        <div className="description-text">Napomena super admina</div>
                                        <textarea placeholder="Unesite napomenu..." className="form-textarea grey w-input"
                                            value={note}
                                            onChange={(e) => setNote(e.target.value)}
                                        ></textarea>
                                    </div>
                                </div>
                                {/* <div className="button-secondary medium">
                                <div>Sačuvaj napomenu</div>
                            </div> */}
                                {reportInfo.reviewNote && (
                                    <div className="div-block-39 one-column">
                                        <div id="w-node-_3b2b0563-5a79-55a1-4ecf-d154d5d11b29-7969b2d6">
                                            <div className="description-text">Postojeća napomena</div>
                                            <div className="input-div white-bg">
                                                <div className="_0-95rem">{reportInfo.reviewNote}</div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                            <div>
                                <div className="description-text">Prijavljeno: {reportInfo.createdAt ? ToLocalDateTimeString(reportInfo.createdAt.toString()) : ''}</div>
                                {reportInfo.reviewedAt && (
                                    <div className="description-text">Rešeno: {ToLocalDateTimeString(reportInfo.reviewedAt.toString())}</div>
                                )}
                            </div>
                            <div className="modal-buttons">
                                <div className="button-secondary medium" onClick={onClose}>
                                    <div>Otkaži</div>
                                </div>
                                <div className="button-primary medium" onClick={handleSaveChanges}>
                                    <div>Sačuvaj izmene</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default UserReportInfoView;